import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../utils/api';

export default function GenderGate() {
  const { t } = useTranslation();
  const { setUser } = useAuth();
  const [gender, setGender] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!gender) {
      setError(t('auth.pleaseSelectGender'));
      return;
    }
    setLoading(true);
    try {
      await api.updateProfile({ gender });
      const updated = await api.getMe();
      setUser(updated);
    } catch (err) {
      setError(err.message || t('profile.updateFailed', 'Failed to update'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1.5rem',
      fontFamily: "var(--font-body)",
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        background: '#000000',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '2.5rem',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: 'linear-gradient(90deg, var(--orange-dark), var(--orange), var(--orange-light))',
        }} />
        <h2 style={{
          fontFamily: "var(--font-heading)",
          fontSize: '1.25rem',
          fontWeight: 600,
          letterSpacing: '0.05em',
          color: '#ffffff',
          marginBottom: '0.5rem',
          textAlign: 'center',
        }}>
          {t('auth.chooseGenderToContinue')}
        </h2>
        <p style={{
          fontSize: '0.85rem',
          color: 'var(--text-muted)',
          marginBottom: '1.5rem',
          textAlign: 'center',
        }}>
          {t('auth.iAmA')}
        </p>
        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{
              marginBottom: '1rem',
              padding: '0.75rem',
              background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: '6px',
              color: '#fca5a5',
              fontSize: '0.85rem',
            }}>
              {error}
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '1.5rem' }}>
            {[['male', '/images/male-icon.png', t('auth.male')], ['female', '/images/female-icon.png', t('auth.female')]].map(([g, iconSrc, label]) => {
              const selected = gender === g;
              return (
                <button
                  key={g}
                  type="button"
                  onClick={() => setGender(g)}
                  style={{
                    padding: '0.85rem',
                    border: `2px solid ${selected ? 'var(--orange)' : 'var(--border)'}`,
                    borderRadius: '6px',
                    background: selected ? 'var(--orange)' : 'transparent',
                    color: '#ffffff',
                    fontFamily: "var(--font-heading)",
                    fontWeight: 700,
                    fontSize: '0.9rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.4rem',
                  }}
                >
                  <img src={iconSrc} alt="" style={{ width: 28, height: 28, objectFit: 'contain' }} />
                  {label}
                </button>
              );
            })}
          </div>
          <button
            type="submit"
            disabled={loading || !gender}
            style={{
              width: '100%',
              padding: '0.9rem',
              background: gender && !loading ? 'var(--orange)' : 'var(--border)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              fontFamily: "var(--font-heading)",
              fontWeight: 600,
              fontSize: '1rem',
              letterSpacing: '0.05em',
              cursor: gender && !loading ? 'pointer' : 'not-allowed',
              opacity: gender && !loading ? 1 : 0.7,
            }}
          >
            {loading ? t('common.loading') : t('auth.continue')}
          </button>
        </form>
      </div>
    </div>
  );
}
